<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<style>
					body {
						display: flex;
						justify-content: center;
						align-items: center;
						min-height: 100vh;
						margin: 0;
						background: #f0f6ff;
					}

					.dots {
						display: flex;
						gap: 10px;
						align-items: center;
					}

					.dot {
						width: 14px;
						height: 14px;
						border-radius: 50%;
						background: #378add;
						animation: bounce 0.9s ease-in-out infinite;
					}

					.dot:nth-child(1) {
						background: #b5d4f4;
						animation-delay: 0s;
					}
					.dot:nth-child(2) {
						background: #378add;
						animation-delay: 0.15s;
					}
					.dot:nth-child(3) {
						background: #185fa5;
						animation-delay: 0.3s;
					}

					@keyframes bounce {
						0%,
						80%,
						100% {
							transform: translateY(0);
						}
						40% {
							transform: translateY(-16px);
						}
					}
				</style>
				<div class="dots">
					<div class="dot"></div>
					<div class="dot"></div>
					<div class="dot"></div>
				</div>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
